import { inject, InjectionKey } from 'vue';

/**
 * Inject a mandatory dependency, throwing an error if it can't be found.
 */
export function injectOrThrow<T>(key: string | InjectionKey<T>): T {
  const value: T | undefined = inject<T>(key);
  if (value !== undefined) {
    return value;
  } else {
    throw new Error(`${key.toString()} not provided by a parent component.`);
  }
}
